import type { FC } from 'react';
import { memo } from 'react';
import {
  logoMobile2024,
  logoDesktop19,
  logo_20Let,
  logo_20Let_mob,
  logo_dr_21_desktop,
  logo_dr_21_mobile,
  logoDesktopNew2025,
  logoNewYear2026,
  logoNewYear2026Mobile
} from '@images';
import { Link } from '@compat/router';
import { isBirthday } from '@constants/birthday';
import './index.scss';

const isNewYear = false;
const isAnniversary = false;
const isNewIcon19th = false;

const mainLogo = isNewIcon19th ? logoDesktop19 : logoDesktopNew2025;

const mobile = isBirthday
  ? logo_dr_21_mobile.x3
  : isNewYear
  ? logoNewYear2026Mobile.x3
  : isAnniversary
  ? logo_20Let_mob.x3
  : logoMobile2024.x3;
const laptop = isBirthday
  ? logo_dr_21_desktop.x3
  : isNewYear
  ? logoNewYear2026.x3
  : isAnniversary
  ? logo_20Let.x3
  : mainLogo.x3;
const desktop = isBirthday
  ? logo_dr_21_desktop.x3
  : isNewYear
  ? logoNewYear2026.x3
  : isAnniversary
  ? logo_20Let.x3
  : mainLogo.x3;

interface LogoProps {
  isSmall?: boolean;
  className?: string;
  to?: string;
}

const Logo: FC<LogoProps> = ({ isSmall = false, className = '', to = '/' }) => (
  <Link className={className} to={to}>
    <span className={isSmall ? 'hidden' : 'flex items-center'}>
      <picture>
        <source
          width='40'
          height='40'
          media='(max-width: 767.98px)'
          srcSet={mobile}
        />
        <source
          width='192'
          height='40'
          media='(min-width: 768px) and (max-width: 1279.98px)'
          srcSet={laptop}
        />
        <img width='192' height='40' src={desktop} alt='Лого' />
      </picture>
    </span>
    <img
      className={isSmall ? 'block' : 'hidden'}
      width='40'
      height='40'
      src={mobile}
      alt='Лого'
    />
  </Link>
);

export default memo(Logo);
